/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const core_chain_about = () => `Core Blockchain stands as a beacon of integrity and innovation in the digital economy. Core platform redefines the blockchain landscape by offering an unstoppable, open-source network that transcends traditional financial boundaries and defines a new internet-of-value.`
